export default "__VITE_ASSET__b56b1419__"